import { Setters, Errors } from '@quickbit/qb-design-system';

export interface Merchant {
  merchantId?: string;
  countryCode: string;
  name: string;
  tosAccepted: boolean;
}

export type BusinessSector =
  | 'Retail & E-commerce'
  | 'Food Delivery & Hospitality'
  | 'Digital Goods & Subscriptions'
  | 'Software & SaaS Services'
  | 'Financial Services & FinTech'
  | 'Travel & Booking Services'
  | 'Health & Wellness'
  | 'Gaming & Entertainment'
  | 'Education & Online Courses'
  | 'Professional & Consulting Services'
  | 'Marketing & Advertising Services'
  | 'Non-Profit & Fundraising'
  | 'Crypto & Blockchain Services'
  | 'Other (please specify)';

export const BUSINESS_SECTORS: Record<BusinessSector, true> = {
  'Retail & E-commerce': true,
  'Food Delivery & Hospitality': true,
  'Digital Goods & Subscriptions': true,
  'Software & SaaS Services': true,
  'Financial Services & FinTech': true,
  'Travel & Booking Services': true,
  'Health & Wellness': true,
  'Gaming & Entertainment': true,
  'Education & Online Courses': true,
  'Professional & Consulting Services': true,
  'Marketing & Advertising Services': true,
  'Non-Profit & Fundraising': true,
  'Crypto & Blockchain Services': true,
  'Other (please specify)': true,
};
export const BUSINESS_SECTOR_OPTIONS = Object.keys(BUSINESS_SECTORS).map(
  (k) => ({ label: k, value: k })
);

export interface ContactInformation {
  postalRegion: string;
  postalNumber: string;
  country: string;
  address1: string;
}

export interface RelatedPersonBase {
  id: string;
  firstName: string;
  lastName: string;
  isPep: boolean;
}

export interface RelatedPerson extends RelatedPersonBase {
  dateOfBirth: Date;
}

export interface RelatedPersonFormData extends RelatedPersonBase {
  dateOfBirth: Date | null;
  role: string;
  placeOfBirth: string;
  address: ContactInformation;
  type: string;
  ssn: string;
}

export interface KybChange {
  changedBy: string;
  state: string;
  created: Date;
}

export type SelectOption = {
  value: string;
  label: string;
};

export interface KybBase {
  fullCompanyName: string;
  registrationNumber: string;
  registeredAddress: ContactInformation;
  businessSectors: BusinessSector[];
  expectedMonthlyVolume: number;
  businessOperations?: string;
  reasonForUse?: string;
  turnover: number;
  expectedMonthlyTransactions: number;
}

export interface KybSave extends KybBase {
  incorporationCountry: string;
  jurisdictions: string;
  relatedPeople?: RelatedPerson[];
}

export interface KybRead extends KybSave {
  changelog: KybChange[];
  riskScore: number;
}
export interface KybFormData extends KybBase {
  jurisdictions: SelectOption[];
  incorporationCountry: string;
  relatedPeople: RelatedPersonFormData[];
}

export type MerchantUseFormType = {
  fields: Merchant;
  setters: Setters<Merchant>;
  errors: Errors<Merchant>;
  edited: boolean;
  hasErrors: boolean;
};

export type KycUseFormType = {
  fields: KybFormData;
  setters: Setters<KybFormData>;
  errors: Errors<KybFormData>;
  edited: boolean;
  hasErrors: boolean;
};
